<template>
  <footer
    :class="{
      show: !hide,
    }"
    :aria-hidden="hide"
  >
    <div class="msrp-wrapper" v-on:click="clickPopupBtn()">
      <div
        class="msrp-content"
        :style="{ visibility: showPricing ? undefined : 'hidden' }"
      >
        <p v-if="getT">
          {{ getT.static.msrp[0].starting_at_text }}
        </p>
        <div class="price-currency-wrapper">
          <h5>
            {{ formatCurrency($store.getters.priceTotal) }}
          </h5>
          <p class="currency" v-if="getT">
            {{ getT.static.currency_code }}
          </p>
          <img
            src="../../assets/icons/icon-info.svg"
            class="info-btn"
            role="button"
            alt="question mark icon"
          />
        </div>
      </div>
    </div>
    <div class="button-wrap" v-on:click="onClick()">
      <button class="next">
        <span v-if="getT">{{ getT.static.msrp[0].next }}</span>
        <img src="../../assets/icons/right-arrow-solid.svg" alt="Right arrow" />
      </button>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from 'vuex';
import {formatCurrency} from '../../helpers/price';
export default {
  name: 'OptionMenuFooter',
  computed: {
    ...mapGetters(['showPricing', 'getT', 'currPool']),
    hide: function () {
      return this.$route.path !== '/customizer';
    },
  },
  methods: {
    formatCurrency,
    onClick: function () {
      this.$router.push('/summary');

      // track event for Google Analytics
      this.$gtag.event('Get A Qoute Clicked', {
        event_category: 'Get Qoute Click',
        event_label: 'Get A Qoute Clicked',
        selected_pool: this.currPool.title,
        msrp_amount: this.$store.getters.priceTotal,
        currency: this.getT ? this.getT.static.currency_code : '',
      });
      this.$gtag.event(this.$store.getters.priceTotal + ' MSRP Logged', {
        event_category: 'Get Qoute Click',
        event_label: 'MSRP Loggged',
        selected_pool: this.currPool.title,
        msrp_amount: this.$store.getters.priceTotal,
        currency: this.getT ? this.getT.static.currency_code : '',
      });
    },
    clickPopupBtn: function () {
      this.$store.commit('showInfoPopup', this.getT ? this.getT.static.contact[0].disclaimer : '');
    },
    toSummary: function () {
      this.$router.push('/summary');
    },
    easeInOutCubic: function (x) {
      return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    },
  },
};
</script>
<style scoped lang="scss">
footer {
  display: flex;
  position: fixed;
  z-index: 10;
  bottom: -6em;
  width: 100%;
  height: $bottom-bar-height;
  overflow: hidden;
  transition: bottom 400ms cubic-bezier(0.215, 0.61, 0.355, 1);
  // animation: fly-in 600ms cubic-bezier(0.215, 0.610, 0.355, 1);
  &.show {
    bottom: 0;
  }
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1em;
    width: 50%;
    @media #{$desktop} {
      width: 100%;
    }
  }
  .button-wrap {
    background-color: $aqua;
    @media #{$desktop} {
      cursor: pointer;
      &:hover {
        background-color: lighten($aqua, 4%);
      }
    }
  }
  .msrp-wrapper {
    background-color: $navy;
    .msrp-content {
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        font-family: 'Europa Bold';
        color: white;
        text-transform: uppercase;
        font-size: 0.56rem;
        letter-spacing: 0.078rem;
        @media screen and (max-width: #{$sm-md}) {
          text-align: center;
        }
      }
      .price-currency-wrapper {
        display: flex;
        align-items: center;
        h5 {
          color: white;
          font-family: 'Austin Bold';
          font-size: 1.25rem;
          letter-spacing: 0.175rem; // 2.8px
          margin: 0 8px;
          @media screen and (max-width: #{$sm-md}) {
            margin: 0;
          }
        }
        p.currency {
          @media screen and (max-width: #{$sm-md}) {
            margin: 0 6px;
          }
        }
        img.info-btn {
          width: 12px;
          height: 12px;
          margin: 0 0 0 8px;
          cursor: pointer;
          @media screen and (max-width: #{$sm-md}) {
            margin: 0;
          }
        }
      }
      @media screen and (max-width: #{$sm-md}) {
        flex-direction: column;
      }
    }
  }
  .button-wrap {
    button.next {
      display: flex;
      align-items: center;
      justify-content: right;
      font-size: 1.25rem;
      letter-spacing: 2.5px;
      border: none;
      background-color: transparent;
      padding: 0;
      font-family: 'Europa Bold';
      img {
        margin-left: 0.7em;
        @media screen and (max-width: #{$sm}) {
          margin-left: 0.4em;
        }
      }
      @media screen and (max-width: #{$sm}) {
        font-size: 1rem;
      }
    }
  }
  @media #{$desktop} {
    flex-direction: column;
    right: 0;
    height: $desktop-bottom-bar-height;
    width: $aside-desktop-width;
    max-width: $max-aside-desktop-width;
    min-width: $min-aside-desktop-width;
    bottom: calc(-1em - #{$desktop-bottom-bar-height});
  }
}
</style>
